export default __webpack_public_path__ + "static/media/drive.e32b0016.svg";